import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import StatsStrip from '../components/common/StatsStrip';

const PartecipaPage = () => {
  return (
    <Layout>
      <section className="hero hero--dark" style={{ minHeight: '60vh', display: 'flex', alignItems: 'center' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <h1 className="text-hero" style={{ fontSize: 'clamp(2.5rem, 6vw, 4.5rem)', lineHeight: 1.1, maxWidth: 800, marginInline: 'auto' }}>
            Unisciti ai<br /><span style={{ color: 'var(--color-primary)' }}>Giovani Democratici</span>
          </h1>
          <p className="text-lead mt-6" style={{ color: 'rgba(255,253,249,0.7)', maxWidth: 550, marginInline: 'auto' }}>Entra a far parte della più grande organizzazione politica giovanile d'Italia.</p>
        </div>
      </section>

      <section className="section"><div className="container">
        <StatsStrip stats={[{ number: '25.000', label: 'Iscritti' }, { number: '850', label: 'Circoli' }, { number: '107', label: 'Federazioni' }, { number: '20', label: 'Regioni' }]} />
      </div></section>

      <section className="section bg-subtle"><div className="container" style={{ maxWidth: 800 }}>
        <h2 className="h2 text-center mb-8">Come partecipare</h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-8)' }}>
          {[
            { step: '1', title: 'Trova il tuo circolo', text: 'Cerca il circolo GD più vicino a te. Ce ne sono oltre 850 in tutta Italia.', link: '/circoli', cta: 'Cerca circolo' },
            { step: '2', title: 'Partecipa alle attività', text: "Vai alla riunione del circolo, partecipa a un evento o a un'assemblea. Non serve essere iscritti per cominciare." },
            { step: '3', title: 'Iscriviti', text: "Compila il modulo di iscrizione e diventa ufficialmente un Giovane Democratico. L'iscrizione è gratuita per gli under 18." },
          ].map((s) => (
            <div style={{ display: 'flex', gap: 'var(--space-6)', alignItems: 'flex-start' }} key={s.step}>
              <div style={{ width: 56, height: 56, borderRadius: 'var(--radius-full)', background: 'var(--color-primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: '1.5rem', fontWeight: 800, flexShrink: 0, fontFamily: 'var(--font-display)' }}>{s.step}</div>
              <div>
                <h3 className="h4 mb-2">{s.title}</h3>
                <p className="text-body-sm text-secondary mb-3">{s.text}</p>
                {s.link && <Link to={s.link} className="btn btn--outline btn--sm">{s.cta}</Link>}
              </div>
            </div>
          ))}
        </div>
      </div></section>

      <section className="section"><div className="container" style={{ maxWidth: 600 }}>
        <h2 className="h2 text-center mb-8">Iscriviti ora</h2>
        <form style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}>
          <div className="grid grid-2" style={{ gap: 'var(--space-4)' }}>
            <input type="text" className="form-input" placeholder="Nome" />
            <input type="text" className="form-input" placeholder="Cognome" />
          </div>
          <input type="email" className="form-input" placeholder="Email" />
          <input type="tel" className="form-input" placeholder="Telefono" />
          <input type="text" className="form-input" placeholder="Città" />
          <select className="form-input"><option>Età</option><option>14-17</option><option>18-21</option><option>22-25</option><option>26-30</option></select>
          <textarea className="form-input" rows="3" placeholder="Perché vuoi partecipare? (facoltativo)"></textarea>
          <button type="submit" className="btn btn--primary btn--lg">Iscriviti ai Giovani Democratici</button>
          <p className="text-meta text-center">Compilando il modulo accetti la nostra Privacy Policy.</p>
        </form>
      </div></section>
    </Layout>
  );
};

export default PartecipaPage;
